import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaginationObject, PageSize } from '@maced/angular-components/lib/pagination/pagination.model';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  paginationObject!: PaginationObject;
  pageSizeList: PageSize[] = [];
  currentUrl: string;

  constructor(
    private router: Router
  ) {
    this.currentUrl = this.router.url.split('?')[0];
  }

  ngOnInit(): void {
    this.setPageintaionObject();
    this.setPageSizeList();
  }

  setPageintaionObject(): void {
    this.paginationObject = {
      totalItems: 200,
      currentPage: 1,
      pageSize: 10
    };
  }

  setPageSizeList(): void {
    this.pageSizeList = [
      {
        id: '5',
        name: '5',
        label: '5',
        active: false,
        url: this.currentUrl
      },
      {
        id: '10',
        name: '10',
        label: '10',
        active: false,
        url: this.currentUrl
      },
      {
        id: '25',
        name: '25',
        label: '25',
        active: false,
        url: this.currentUrl
      },
      {
        id: '50',
        name: '50',
        label: '50',
        active: false,
        url: this.currentUrl
      },
      {
        id: '100',
        name: '100',
        label: '100',
        active: false,
        url: this.currentUrl
      }
    ]
  }
}